import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
require('../../global/CommonListModal.scss')
import moment from 'moment-timezone'

import Picker from 'react-mobile-picker'
import { EMPTY_OBJECT } from '../../constants/globalConstants'
import { getConvertedDate } from '../../utils/helper'



function ScrollCalendar(props) {

    const[pickerDateValue, setPickerDateValue] = useState(null)
    const[btnDisabled, setBtnDisabled] = useState(true)
    

    const facilityLocData = JSON.parse(localStorage.getItem('faclityData'))
    let today = props.extend ? moment(props.entryDateTime).format('YYYY-MM-DD HH:mm:ss') : moment(new Date()).tz(facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')
    
    
    // let updatedDate = new Date(today)
    // console.log(today, new Date(today).getHours(), 'today')
    let nextXDays = function (days) {
        let dayArr = []
        for(let i = 0; i < days; i++) {
            let date = new Date(getConvertedDate(moment(today).add(i, 'days')?.format('YYYY-MM-DD hh:mm:ss')))
            let day = moment(date).format('DD')
            let month = moment(date).format('MMM')
            let year = moment(date).format('YYYY')
            if(i === 0 && !props.isDateShow) {
                dayArr.push('Today yearto '+year)
            } else {
                dayArr.push(month +' '+ day + ' yearto ' + year)
            }
            // updatedDate.setDate(updatedDate.getDate() + 1)
        }
        return dayArr
    }
    let days = nextXDays(30)

    let hours = function() {
        let hours = []
        for(let i = 1; i <= 12; i++) {
            hours.push(i < 10 ? '0'+i+'' : i+'')
        }
        return hours
    }
    let minutes = function() {
        let min = []
        for(let i = 0; i <= 59; i++) {
            min.push(i < 10 ? '0'+i+'' : i+'')
        }
        return min
    }

    const selections = [
        {mapkey: days, val: 'date'},
        {mapkey: hours(), val: 'hour'},
        {mapkey: minutes(), val: 'minutes'},
        {mapkey: ['AM', 'PM'], val: 'ampm'}
    ]
    const { isScrollCalendarModal, setIsScrollCalendarModal, setEntryDateTime, handleEntryTime } = props
    const [pickerValue, setPickerValue] = useState({
        date: '',
        hour: '',
        minutes: '',
        ampm: '',
    })
    // const d2 = moment(new Date(
    //     pickerValue.date.includes('Today yearto') ? `${new Date(today).toLocaleString('default', { month: 'short' })} ${new Date(today).getDate()} ${new Date(today).getFullYear()}, ${pickerValue.ampm === 'PM' ? Number(pickerValue.hour)+12 + '' : pickerValue.hour}:${Number(pickerValue.minutes) +'' }${':01'}`:
    //     `${pickerValue.date.split(' yearto ').join(' ')}, ${pickerValue.ampm === 'PM' ? Number(pickerValue.hour)+12 + '' : pickerValue.hour}:${Number(pickerValue.minutes) +'' }${':01'}`
    // )
    // // .toLocaleString('en-US',{timeZone: facilityLocData?.facility?.timezone})
    // ).format('MM-DD-YYYY hh:mm A')
    const str = pickerValue.date.replace('yearto ', '')
    // const d2 = pickerValue.date.includes('Today yearto') ?  moment(today).hours(pickerValue.hour).minutes(pickerValue.minutes).format('MM-DD-YYYY hh:mm') :
    moment(str).hours(pickerValue.hour).minutes(pickerValue.minutes).format('MM-DD-YYYY hh:mm')
    // console.log(drive2, 'drive2')
    // const buttonEnableDate = pickerValue.date.includes('Today yearto') ? moment(`${moment(today).format('MM')} ${moment(today).format('DD')} ${moment(today).format('YYYY')} ${moment().hour(pickerValue.hour).format('hh')}:${moment().hour(pickerValue.minutes).format('mm')} ${moment().hour(pickerValue.hour).format('A')}`).subtract(5, 'minutes').format('MM-DD-YYYY hh:mm A') : moment(new Date(
    //     `${pickerValue.date.split(' yearto ').join(' ')}, ${pickerValue.ampm === 'PM' ? Number(pickerValue.hour)+12 + '' : pickerValue.hour}:${(Number(pickerValue.minutes) - 1) +'' }${':01'}`
    // )).format('MM-DD-YYYY hh:mm A')

    // console.log(new Date(today).getHours(), pickerValue, 'today', d2)
    const setStringData = (opt) => {
        let strToReturn = opt.split(' yearto ')
        return strToReturn[0]
    }
    
    const handleClick = () => {
        // console.log(pickerDateValue)
        setEntryDateTime(pickerDateValue)
        handleEntryTime(pickerDateValue)
        props.setSeletedRateBand('')
        setIsScrollCalendarModal(false)
        // console.log(pickerDateValue, 'pickerDateValue')
    }
    useEffect(() => {
        let pickerDtSet = new Date(getConvertedDate(moment(today)?.format('YYYY-MM-DD hh:mm:ss')))
        setEntryDateTime(JSON.stringify(moment(pickerDtSet).format('MM-DD-YYYY hh:mm A')))
    }, [today])

    useEffect(() => {
        if(!props.extend) {
            let pickerDtSet = new Date(getConvertedDate(moment(today)?.format('YYYY-MM-DD hh:mm:ss A')))
            // console.log(pickerDtSet, moment(pickerDtSet).format('h'), 'pickerDtSet')
            setPickerValue({
                date: 'Today yearto '+ moment(pickerDtSet).year(),
                hour: moment(pickerDtSet).format('hh'),
                minutes: moment(pickerDtSet).format('mm'),
                ampm: moment(pickerDtSet).format('A'),
            })
        }
    }, [isScrollCalendarModal])
    useEffect(() => {
        if(props.extend) {
            const savedFacility = JSON.parse(localStorage.getItem('faclityData'))
            const currentDate = new Date(getConvertedDate(moment(new Date()).tz(savedFacility?.facility?.timezone ? savedFacility?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD hh:mm:ss A')))
            let pickerDtSet = new Date(getConvertedDate(moment(today)?.format('YYYY-MM-DD hh:mm:ss A')))
            // console.log(pickerDtSet, moment(pickerDtSet).format('h'), 'pickerDtSet')
            let checkExtendDT = moment(pickerDtSet).isAfter(currentDate, 'days')
            // console.log(currentDate, pickerDtSet, checkExtendDT, 'checkExtendDT')
            setPickerValue({
                date: checkExtendDT ? moment(pickerDtSet).format('MMM') + ' ' + moment(pickerDtSet).format('DD') +' yearto ' + moment(pickerDtSet).year() : 'Today yearto '+ moment(pickerDtSet).year(),
                hour: moment(pickerDtSet).format('hh'),
                minutes: moment(pickerDtSet).format('mm'),
                ampm: moment(pickerDtSet).format('A'),
            })
            // console.log(pickerDtSet, 'pickerDtSet')
        }
    }, [today])

    const handleCustomDatePicker = (e) => {
        setPickerValue(e)
        const dataString = new Date(e.date.split(' yearto ').join(' ').split(' ').join('-'))
        const currentTimeinSec = moment(new Date()).tz(facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York').format('ss')
        const pickerDate = `${e?.date?.includes('Today yearto') ? moment(new Date()).tz(facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD') : moment(dataString, 'YYYY-MM-DD').format('YYYY-MM-DD')} ${e?.hour}:${e?.minutes}:${currentTimeinSec} ${e?.ampm}`
        const formattedpickerDate = getConvertedDate(pickerDate)
        setPickerDateValue(formattedpickerDate)
        setBtnDisabled(moment(today).isSameOrAfter(formattedpickerDate, 'minutes'))
    }

    return (
        <div>
            {pickerValue.date ? 
            <Modal show={isScrollCalendarModal} onHide={() => setIsScrollCalendarModal(false)} centered className='commonModalDialogbox' animation={false}>
                <Modal.Header className='justify-content-around'><h5 className='text-primary'>Pick Date & Time</h5></Modal.Header>
                <Modal.Body className='scrollable-Modal'>
                    <Picker wheel="normal" value={pickerValue} onChange={(e) => {
                        handleCustomDatePicker(e)
                    }} option={pickerValue}>
                        {selections.map((name, ind) => (
                            <Picker.Column key={'mapkey_'+ind} name={name.val}>
                                {name['mapkey'].map(option => (
                                    <Picker.Item key={option} value={option}>
                                        {setStringData(option)}
                                    </Picker.Item>
                                ))}
                            </Picker.Column>
                        ))}
                    </Picker>
                </Modal.Body>
                <Modal.Footer className='flex-column'>
                    <h6 className='border w-100 rounded p-2 text-center'><div className='p-1'>
                        Exit By - {
                        pickerValue.date.includes('Today yearto') ? `${moment().format('MMM')} ${moment().tz(facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York').date()}, ${moment().year()} ${moment().hour(pickerValue.hour).format('hh')}:${moment().minutes(pickerValue.minutes).format('mm')} ${pickerValue.ampm}`:
                        `${pickerValue.date.split(' yearto ').join(', ')} ${moment().hour(pickerValue.hour).format('hh')}:${moment().minutes(pickerValue.minutes).format('mm')} ${pickerValue.ampm}`}
                    </div></h6>
                    
                    <button 
                        onClick={handleClick} 
                        disabled={btnDisabled} 
                        className='btn btn-primary w-100 text-white'>Done</button>
                </Modal.Footer>
                {/* <span className='text-danger text-center mb-2' onClick={() => setIsScrollCalendarModal(false)}>Close</span> */}
            </Modal> : ''}
        </div>
    )
}

ScrollCalendar.propTypes = {
    dispatch: PropTypes.func,
    isScrollCalendarModal: PropTypes.bool,
    setIsScrollCalendarModal: PropTypes.func,
    isThisVehicleModal: PropTypes.bool,
    setEntryDateTime: PropTypes.func,
    handleEntryTime: PropTypes.func,
    setselctedDateTime: PropTypes.func,
    selctedDateTime: PropTypes.object,
    extend: PropTypes.bool,
    entryDateTime: PropTypes.string,
    isDateShow: PropTypes.bool,
    setSeletedRateBand: PropTypes.func,
}

ScrollCalendar.defaulProps = {
    dispatch: noop,
    isScrollCalendarModal: false,
    setIsScrollCalendarModal: noop,
    isThisVehicleModal: false,
    setEntryDateTime: noop,
    handleEntryTime: noop,
    setselctedDateTime: noop,
    selctedDateTimeL: EMPTY_OBJECT,
    extend: false,
    entryDateTime: '',
    isDateShow: false,
    setSeletedRateBand: noop,
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(ScrollCalendar)

